import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '@/components/home/HeroSection';
import ServicesSection from '@/components/home/ServicesSection';
import SpecialsSection from '@/components/home/SpecialsSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import AboutSection from '@/components/home/AboutSection';
import ServiceAreasSection from '@/components/home/ServiceAreasSection';
import FAQSection from '@/components/home/FAQSection';
import BlogPreviewSection from '@/components/home/BlogPreviewSection';
import LoyaltySection from '@/components/home/LoyaltySection';
import { FinancingBanner } from '@/components/FinancingBanner';
import { generateWebSiteSchema, generateOrganizationSchema } from '../utils/schemaMarkup';
import { useSchemaMarkup } from '../utils/useSchemaMarkup';

const HomePage = () => {
  // Generate homepage schemas
  const webSiteSchema = generateWebSiteSchema();
  const organizationSchema = generateOrganizationSchema();

  // Inject schemas into document head
  useSchemaMarkup([webSiteSchema, organizationSchema], 'homepage');

  return (
    <main>
      <Helmet>
        <title>ComfortMaster Heating & Air | AC Company Lexington & Nicholasville KY</title>
        <meta name="description" content="ComfortMaster is your trusted HVAC company in Lexington, Nicholasville & Central Kentucky. Expert AC repair, furnace installation, heating services. 25+ years experience. Call (859) 357-6803 for free estimate." />
        <meta name="keywords" content="ac company lexington, hvac company nicholasville, ac repair lexington, ac service lexington, hvac company near me, local ac company, ac replacement, heating repair, furnace repair, american standard ac, trane ac" />
        <link rel="canonical" href="https://comfortmasterheating.com/" />
      </Helmet>
      <HeroSection />
      <ServicesSection />
      <FinancingBanner />
      <SpecialsSection />
      <TestimonialsSection />
      <AboutSection />
      <ServiceAreasSection />
      <FAQSection />
      <BlogPreviewSection />
      <LoyaltySection />
    </main>
  );
};

export default HomePage;
